"use strict";
import { Coder } from "./abstract-coder";
export class BooleanCoder extends Coder {
    constructor(localName) {
        super("bool", "bool", localName, false);
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/abi/lib.esm/coders/boolean.js
// module id = null
// module chunks = 